import { v4 as uuid } from 'uuid';
import { ActionType } from '../../models/Action';
import { Input } from '../../models/Input';
import { SendRawMessageActionSettings } from '../../models/SendRawMessageActionSettings';
import { ActionViewModel } from '../../models/viewModels/ActionViewModel';
import { ContentActionViewModel } from '../../models/viewModels/ContentActionViewModel';
import { InputViewModel } from '../../models/viewModels/InputViewModel';
import { OutputViewModel } from '../../models/viewModels/OutputViewModel';
import { StateViewModel } from '../../models/viewModels/StateViewModel';
import { SmartSalesConstants } from '../SmartSalesConstants';
import { getSmartSalesEnteringCustomActions, smartSalesLeavingCustomActions } from './Actions';
import { smartSalesConditionOutputs } from './Outputs';
export const getNewSmartSalesState = (title, { token, waCtaMessage, defaultDisabledCtaMsg }, textContent) => {
    return new StateViewModel({
        id: `${SmartSalesConstants.STATE_ID_PREFIX}${uuid()}`,
        root: false,
        $invalid: false,
        stateVersion: SmartSalesConstants.CURRENT_SMART_SALES_VERSION,
        $contentActions: [
            new ContentActionViewModel({
                action: new ActionViewModel({
                    type: ActionType.SendRawMessage,
                    $typeOfContent: 'raw-content',
                    settings: new SendRawMessageActionSettings({
                        type: '{{smartSalesMessage@type}}',
                        rawContent: '{{smartSalesMessageContent}}',
                    }),
                }),
            }),
            new ContentActionViewModel({
                input: InputViewModel.create(textContent, new Input({
                    bypass: false,
                    expiration: '23:0',
                }), false),
            }),
        ],
        $title: title,
        $enteringCustomActions: getSmartSalesEnteringCustomActions({ token, waCtaMessage, defaultDisabledCtaMsg }),
        $leavingCustomActions: smartSalesLeavingCustomActions,
        $conditionOutputs: smartSalesConditionOutputs,
        $defaultOutput: new OutputViewModel({ stateId: 'fallback' }),
    });
};
